var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophyGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.63636 9.292V10.6667H10.8182V12H3.18182V10.6667H6.36364V9.292C5.13335 9.12947 4.00198 8.50218 3.18182 7.52783C2.36166 6.55349 1.90911 5.29907 1.90909 4V0H12.0909V4C12.0909 5.29907 11.6383 6.55349 10.8182 7.52783C9.99802 8.50218 8.86664 9.12947 7.63636 9.292ZM3.18182 1.33333V4C3.18182 5.06087 3.58409 6.07828 4.30014 6.82843C5.01619 7.57857 5.98736 8 7 8C8.01264 8 8.98381 7.57857 9.69986 6.82843C10.4159 6.07828 10.8182 5.06087 10.8182 4V1.33333H3.18182ZM0 1.33333H1.27273V4H0V1.33333ZM12.7273 1.33333H14V4H12.7273V1.33333Z",
    fill: "#1CB978"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyGreen);
export default __webpack_public_path__ + "static/media/trophy-green.f2f7050cfdecdfaa80ed90e3da96f9ed.svg";
export { ForwardRef as ReactComponent };